import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  Container,
  Grid,
  CardMedia,
} from "@material-ui/core";
import ConcertIntroSection from "./ConcertIntroSection";
import ConcertDescribeSection from "./ConcertDescribeSection";

// import { stateToHTML } from "draft-js-export-html";
// import { Editor, EditorState, convertToRaw, convertFromRaw } from "draft-js";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionRoot: {
      background: "white",
      // minHeight: "90vh",
      marginTop: "10rem",
      // marginBottom: "8%",
      //   padding: "0 4.948% 109px 4.948%",
      paddingLeft: "6rem",
      paddingRight: "6rem",
      [theme.breakpoints.down("xs")]: {
        marginTop: "5rem",

        paddingLeft: 32,
        paddingRight: 32,
      },
    },
    sectionRoot2: {
      background: "white",
      minHeight: "55vh",
      // marginTop: "8%",
      // marginBottom: "8%",
      //   padding: "0 4.948% 109px 4.948%",
      // paddingLeft: "6rem",
      // paddingRight: "6rem",
      // paddingTop: "56.25%",
      // backgroundSize: "100%",
      // backgroundPosition: "50% 50%",
    },
    categoryText: {
      // fontFamily:"Black Han Sans"
      fontFamily: "Noto Sans KR",
      fontSize: 48,
      color: "black",
      fontWeight: 900,
      letterSpacing: -4,
      paddingBottom: 16,
      [theme.breakpoints.down("xs")]: {
        fontSize: 32,
        paddingBottom: 8,
      },
    },
    subCategory: {
      fontFamily: "Noto Sans KR",
      fontSize: 40,
      color: "black",
      fontWeight: 500,
      //   paddingLeft:6
      letterSpacing: -1,
    },
    winnerDiv: {
      // paddingTop: "4rem"
    },
    winnerCategory: {
      fontSize: 20,
      fontWeight: 900,
      paddingRight: 32,
      //   color: "#7a5f50",
      color: "black",
      fontFamily: "Noto Sans KR",
      paddingBottom: 8,
    },
    winnerName: {
      fontSize: 20,
      fontWeight: 400,
      color: "black",
      fontFamily: "Noto Sans KR",
    },
    winnerTopDiv: {
      //   display: "flex",
      paddingBottom: 32,
    },
  })
);
interface ConcertPageInfoProps {
  // history: History;
  rowData: any;
}

function ConcertPageInfo({ rowData }: ConcertPageInfoProps) {
  // const { history } = props;

  const [info_title, setInfoTitle] = useState<any>(null);
  const [info_url, setInfoUrl] = useState<any>(null);
  const [info_content, setInfoContent] = useState<any>(null);

  useEffect(() => {
    setInfoTitle(rowData.title);
    setInfoUrl(rowData.feat_img.url);
    setInfoContent(rowData.description);
    // return () => {};
  }, [rowData]);
  // let html = stateToHTML(contentState.getCurrentContent());

  const classes = useStyles();
  return (
    <Container
      maxWidth={false}
      disableGutters={true}
      className={classes.sectionRoot}
    >
      <Container maxWidth={"xl"} disableGutters={true}>
        {info_title ? (
          <ConcertIntroSection
            categoryInfo={rowData.subTitle}
            title={
              <div>
                <div className={classes.categoryText}>{info_title}</div>
              </div>
            }
            describe={rowData.pageIntroduce}
          />
        ) : null}
        {info_url ? (
          <ConcertDescribeSection image={info_url} content={info_content} />
        ) : null}
      </Container>
    </Container>
  );
}

export default ConcertPageInfo;
